export const hover = content => {
  return "\n        @media (any-hover: none) {\n            &:active {\n                ".concat(content, "\n            }\n        }\n        @media (any-hover: hover) {\n            &:hover {\n                ").concat(content, "\n            }\n        }\n    ");
};
export const mobile = "@media (max-width: 800px), (max-height: 600px)";
export const isMobile = () => innerWidth < 800 || innerHeight < 600;